import { restClient } from '../client';
import { Appointment } from '../resources';


export type UpcomingRecurringSessionsInput = {
  series_id: string;
  limit: number;
};


export type UpcomingRecurringSessionsOutput = {
  data: Appointment[];
};


export const upcomingRecurringSessions = (params: UpcomingRecurringSessionsInput) => restClient.request<UpcomingRecurringSessionsOutput>('/api/v1/appointments/recurring-sessions', {
  method: 'GET',
  params: params,
});
